import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context/AppContext";
import formatCategory from "../utils/formatCategory";

const MOBILE_QUERY = "(max-width: 899px)";

const formatMiles = (miles) => `${Math.max(miles, 0.1).toFixed(1)} mi`;

function ResultsList() {
  const { middleGround, searched, filters, selectedId, setSelectedId } =
    useContext(AppContext);
  const [open, setOpen] = useState(true);
  const itemRefs = useRef({});

  // Show the sheet again whenever a new set of results comes in
  useEffect(() => {
    setOpen(true);
  }, [middleGround]);

  // Keep the selected venue in view when it's picked from the map
  useEffect(() => {
    itemRefs.current[selectedId]?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }, [selectedId]);

  const select = (id) => {
    setSelectedId(id);
    // On phones the sheet covers the map, so get it out of the way
    if (window.matchMedia(MOBILE_QUERY).matches) setOpen(false);
  };

  if (!searched) {
    return (
      <div className="results results--empty">
        <p>
          Add both addresses to see spots from our guides that sit right
          between you.
        </p>
      </div>
    );
  }

  if (middleGround.length === 0) {
    return (
      <div className="results results--empty">
        <p>
          {filters.length > 0
            ? "No spots match these categories. Try removing a filter."
            : "No spots found between these addresses."}
        </p>
      </div>
    );
  }

  return (
    <section
      className={`results ${open ? "results--open" : ""}`}
      aria-label="Spots in the middle"
    >
      <button
        type="button"
        className="results__header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>
          {middleGround.length} spots in the middle, closest first
        </span>
        <span className="results__toggle" aria-hidden="true" />
      </button>

      <ol className="results__list">
        {middleGround.map(({ properties }) => {
          const [guide, ...moreGuides] = properties.guides;
          const category = properties.categories[0];
          return (
            <li
              key={properties.id}
              ref={(el) => (itemRefs.current[properties.id] = el)}
              className={`result ${
                selectedId === properties.id ? "result--selected" : ""
              }`}
            >
              <button
                type="button"
                className="result__main"
                onClick={() => select(properties.id)}
              >
                <span className="result__rank">{properties.rank}</span>
                <span className="result__body">
                  <span className="result__name">{properties.Locations}</span>
                  {category && (
                    <span className="result__category">
                      {formatCategory(category)}
                    </span>
                  )}
                  <span className="result__distance">
                    {formatMiles(properties.milesFromA)} from you,{" "}
                    {formatMiles(properties.milesFromB)} from them
                  </span>
                </span>
              </button>
              {guide && (
                <a
                  className="result__guide"
                  href={`https://thenextfunthing.com/la-guide/${guide.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {guide.Name}
                  {moreGuides.length > 0 &&
                    ` (and ${moreGuides.length} more ${
                      moreGuides.length === 1 ? "guide" : "guides"
                    })`}
                </a>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}

export default ResultsList;
